import { Box } from "@mui/material";
import React from "react";
import TopBar from "./TopBar";
import { Outlet } from "react-router-dom";
import SideNav from "./SideNav";

const DashboardLayout = () => {
  return (
    <>
      <Box className="hide_scrollbar" sx={{ display: "flex", height:'100vh' }}>
          <SideNav />
        <Box sx={{ flex:1,display:'flex', flexDirection:'column'  }}> 
        <Box>

            <TopBar />
        </Box> 
          <Box className="hide_scrollbar" sx={{ p: 2, pt:2, height:'95vh', overflowY:'auto',   }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;
